import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-service-history',
  templateUrl: './service-history.component.html',
  styleUrls: ['./service-history.component.css']
})
export class ServiceHistoryComponent implements OnInit {
  serviceHistory: any[] = [];
  filteredHistory: any[] = [];
  selectedFilter: string = 'all';
  searchTerm: string = '';

  filterOptions = [
    { value: 'all', label: 'All Services' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'recurring', label: 'Recurring' }
  ];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.loadServiceHistory();
  }

  loadServiceHistory(): void {
    // Mock service history data
    this.serviceHistory = [
      {
        id: 1,
        serviceName: 'Weekly Lawn Care Service',
        providerName: 'Green Thumb Landscaping',
        date: new Date(2025, 5, 15),
        status: 'completed',
        price: 93.99,
        duration: '2 hours',
        rating: 5,
        review: 'Excellent service! They were professional and on time.',
        isRecurring: true,
        nextSchedule: new Date(2025, 6, 1)
      },
      {
        id: 2,
        serviceName: 'House Cleaning Service',
        providerName: 'Sparkle Clean Services',
        date: new Date(2025, 4, 28),
        status: 'completed',
        price: 128.99,
        duration: '3 hours',
        rating: 4,
        review: 'Great job! Very thorough cleaning.',
        isRecurring: false
      },
      {
        id: 3,
        serviceName: 'Plumbing Repair',
        providerName: 'Quick Plumbing Co.',
        date: new Date(2025, 3, 10),
        status: 'completed',
        price: 250.00,
        duration: '1.5 hours',
        rating: 5,
        review: 'Fixed the issue quickly and efficiently.',
        isRecurring: false
      },
      {
        id: 4,
        serviceName: 'Carpet Cleaning',
        providerName: 'Fresh Carpet Solutions',
        date: new Date(2025, 2, 5),
        status: 'cancelled',
        price: 0,
        duration: 'N/A',
        reason: 'Cancelled due to scheduling conflict',
        isRecurring: false
      },
      {
        id: 5,
        serviceName: 'Monthly AC Maintenance',
        providerName: 'Cool Air Services',
        date: new Date(2025, 1, 15),
        status: 'completed',
        price: 75.00,
        duration: '45 minutes',
        rating: 4,
        review: 'Professional and timely service.',
        isRecurring: true,
        nextSchedule: new Date(2025, 2, 15)
      }
    ];

    this.applyFilters();
  }

  applyFilters(): void {
    let filtered = [...this.serviceHistory];

    // Apply status filter
    if (this.selectedFilter !== 'all') {
      if (this.selectedFilter === 'recurring') {
        filtered = filtered.filter(s => s.isRecurring);
      } else {
        filtered = filtered.filter(s => s.status === this.selectedFilter);
      }
    }

    // Apply search filter
    if (this.searchTerm.trim()) {
      const searchLower = this.searchTerm.toLowerCase();
      filtered = filtered.filter(s =>
        s.serviceName.toLowerCase().includes(searchLower) ||
        s.providerName.toLowerCase().includes(searchLower)
      );
    }

    this.filteredHistory = filtered;
  }

  onFilterChange(filter: string): void {
    this.selectedFilter = filter;
    this.applyFilters();
  }

  onSearchChange(term: string): void {
    this.searchTerm = term;
    this.applyFilters();
  }

  getTotalSpent(): number {
    return this.serviceHistory
      .filter(s => s.status === 'completed')
      .reduce((sum, s) => sum + s.price, 0);
  }

  getTotalServices(): number {
    return this.serviceHistory.filter(s => s.status === 'completed').length;
  }

  getAverageRating(): number {
    const ratedServices = this.serviceHistory.filter(s => s.rating);
    if (ratedServices.length === 0) return 0;
    const totalRating = ratedServices.reduce((sum, s) => sum + s.rating, 0);
    return Math.round((totalRating / ratedServices.length) * 10) / 10;
  }

  goBack(): void {
    this.router.navigate(['/dashboard']);
  }
}
